<template>
    <div>
        <!-- Breadcrumb Section Start -->
        <section class="breadscrumb-section pt-0">
            <div class="container-fluid-lg">
                <div class="row">
                    <div class="col-12">
                        <div class="breadscrumb-contain">
                            <h2 class="mb-2">{{ $t('Password Reset')}}</h2>
                            <nav>
                                <ol class="breadcrumb mb-0">
                                    <li class="breadcrumb-item active">{{ $t('Password Reset')}}</li>
                                    <li class="breadcrumb-item">
                                        <router-link :to="{name: 'home', params: { lang : $i18n.locale }}" >
                                            <i class="fa-solid fa-house"></i>
                                        </router-link>
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Breadcrumb Section End -->

        <!-- log in section start -->
        <section class="log-in-section background-image-2 section-b-space">
            <div class="container-fluid-lg w-100">
                <div class="row">
                    <div class="col-xxl-4 col-xl-5 col-lg-6 col-sm-8 mx-auto">
                        <div class="log-in-box">
                            <div class="log-in-title">
                                <h3>{{ $t('Enter the verification code sent by SMS.')}}</h3>
<!--                                <h4>{{ $t('You will receive a verification code on your mobile phone, through which you will be able to change your account password.') }}</h4>-->
                            </div>


                            <div v-if="error !== null" class="alert alert-danger alert-dismissible fade show" :class="{ 'show' : error !== null }" role="alert">
                                <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" @click="error = null"></button>
                                <strong>{{error}}</strong>
                            </div>


                            <div class="input-box">
                                <form class="row g-4" @submit.prevent="reset()">

                                    <div class="col-12">
                                        <div class="form-floating theme-form-floating log-in-form">
                                            <input type="tel" class="form-control pe-1" id="login-mobile" placeholder="5×××××"
                                                   aria-label="mobile" aria-describedby="mobile" v-model="user.mobile" dir="ltr"
                                                   :class="{ 'is-invalid' : isInvalid('mobile')}" disabled>
                                            <div class="invalid-feedback" v-if="isInvalid('confirmPassword')">
                                                {{  isInvalid('confirmPassword') }}
                                            </div>

                                            <label for="login-mobile">{{ $t('Phone number') }}</label>
                                        </div>
                                    </div>

                                    <div class="col-12">
                                        <div class="form-floating theme-form-floating log-in-form">
                                            <input type="tel" class="form-control pe-1" id="login-code"
                                                   aria-label="code" aria-describedby="code" v-model="user.code" dir="ltr"
                                                   :class="{ 'is-invalid' : isInvalid('code')}">
                                            <div class="invalid-feedback" v-if="isInvalid('confirmPassword')">
                                                {{  isInvalid('confirmPassword') }}
                                            </div>

                                            <label for="login-code">{{ $t('Verification Code') }}</label>
                                        </div>
                                    </div>


                                    <div class="col-12">
                                        <div class="form-floating theme-form-floating log-in-form">
                                            <input type="password" class="form-control pe-1" id="login-password"
                                                   aria-label="password" aria-describedby="password" v-model="user.password" dir="ltr"
                                                   :class="{ 'is-invalid' : isInvalid('password')}" >
                                            <div class="invalid-feedback" v-if="isInvalid('confirmPassword')">
                                                {{  isInvalid('confirmPassword') }}
                                            </div>

                                            <label for="login-password">{{ $t('New Password') }}</label>
                                        </div>
                                    </div>

                                    <div class="col-12">
                                        <div class="form-floating theme-form-floating log-in-form">
                                            <input type="password" class="form-control pe-1" id="login-confirmPassword"
                                                   aria-label="password" aria-describedby="password" v-model="user.confirmPassword" dir="ltr"
                                                   :class="{ 'is-invalid' : isInvalid('confirmPassword')}" >
                                            <div class="invalid-feedback" v-if="isInvalid('confirmPassword')">
                                                {{  isInvalid('confirmPassword') }}
                                            </div>

                                            <label for="login-confirmPassword">{{ $t('Confirm Password') }}</label>
                                        </div>
                                    </div>




                                    <div class="col-12">
                                        <button class="btn btn-animation w-100 justify-content-center" type="submit">
                                            {{ $t('Reset Password')}}
                                        </button>
                                    </div>

                                </form>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- log in section end -->
    </div>

</template>

<script>
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
    inject: ['auth'],
    data() {
        return {
            user: {
                mobile : this.$route.query?.mobile
            },
            error: null,
            show_confirmPassword: false,
            show_password: false,
            validationErrors: null,
        }
    },
    watch: {
        '$userLoggedIn.value': function (newVal) {
            if(newVal === true){
                this.$router.push({name: 'home', params: { lang : this.$i18n.locale }});
            }
        },
    },
    methods: {
        isInvalid( name ) {
            return this.validationErrors != null ? this.validationErrors[name]?.join() : false;
        },
        reset() {

            const that = this;
            this.error = null;
            this.validationErrors = null;

            const id = toast.info(this.$t('The new password is being saved.'), {
                'icon': ' fa-solid fa-comment-sms >'
            });

            axios.post('reset_password',
                this.user
            ).then(response => {

                toast.dismiss(id);

                toast.success(response.data.message  ,{
                    timeout: 3000,
                },{ icon: 'fa-solid fa-circle-check'  });

                this.$router.push({name: 'login', params: { lang : that.$i18n.locale } });

            }) .catch(function (error) {
                toast.dismiss(id);
                if (error.response) {
                    that.validationErrors = error.response.data.errors ;
                }
            });


        }
    },
}
</script>
